import { type RankingInfo, rankItem, rankings } from '@tanstack/match-sorter-utils'
import { filterFns, type Row } from '@tanstack/react-table'
import type { DataTableFilterOption, DataTableLocalization, DataTableRowData } from '../types'

const fuzzy = <TData extends DataTableRowData>(
  row: Row<TData>,
  columnId: string,
  filterValue: number | string,
  addMeta: (item: RankingInfo) => void,
) => {
  const itemRank = rankItem(row.getValue(columnId), filterValue as string, {
    threshold: rankings.MATCHES,
  })
  addMeta(itemRank)
  return itemRank.passed
}

// biome-ignore lint/suspicious/noExplicitAny: TODO - fix type definition
fuzzy.autoRemove = (val: any) => !val

export const DataTableFilterFns = {
  ...filterFns,
  fuzzy,
}

export function localizedFilterOption(
  localization: DataTableLocalization,
  option: DataTableFilterOption,
) {
  if (!option) {
    return ''
  }
  const key = `filter${option[0].toUpperCase()}${option.slice(1)}`
  return localization[key as keyof DataTableLocalization] ?? ''
}
